import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const HowToHelpChildrenOvercomeAnxietyDuringTheWarPage = () => {
  return (
    <Layout>
      <article>
        <h2>Як допомогти дітям подолати тривогу під час війни?</h2>

        <p className="top-spacing-big">
          Ми живемо в страшні часи. І якщо дорослі відчувають хвилювання з приводу поточних подій, уявіть, що мають
          відчувати наші діти.
        </p>
        <p>
          <strong>У дітей є вагомі причини переживати занепокоєння.</strong>
        </p>
        <p>
          Діти стресують, коли починаються розмови про повномасштабну війну, про те, що один з батьків може податися в
          армію.
        </p>
        <p>
          Додається напруга й через те, що діти думають, що через проблеми в економіці мама чи тато можуть залишитися
          без роботи.
        </p>
        <p>Ось сім способів допомогти їм (і вам!) полегшити надмірну тривогу</p>
        <p>
          <strong>Поставтеся до тривоги серйозно</strong>
        </p>
        <p>
          У тривожних дітей у два-чотири рази більша ймовірність розвитку депресії, а в підлітковому віці вони набагато
          частіше зловживають психоактивними речовинами. Симптоми стресу проявляються у дітей у віці від трьох років.{' '}
        </p>
        <p>
          <strong>
            Налаштуйтеся на емоційний стан вашої дитини. Уважно спостерігайте за дитиною і подивіться, як вона
            справляється зі стресом.
          </strong>
        </p>
        <p>
          Наприклад: чи боїться він залишитися на самоті чи перебувати в темних чи закритих місцях, мати труднощі з
          концентрацією уваги чи надмірно дратівлива, чи боязко реагує на будь-які раптові звуки, повертається до
          моделей поведінки, які раніше переросли, поводить себе добре чи істерить, бачить кошмари, тощо?
        </p>
        <p>
          <strong>Забезпечте безпеку</strong>
        </p>
        <p>Першочерговим завданням є запевнити дитину, що їй нічого не загрожує.</p>
        <p>
          Наголошуйте своїй дитині на тому, що люди вживають заходів, щоб зберегти нашу країну в безпеці та допомогти
          тим, хто постраждав: поліцейські, медики, військові, пожежники. Обійміть, слухайте і будьте поруч. Пам&apos;ятайте,
          що травмовані діти є більш вразливими.
        </p>
        <p>
          <strong>Слухайте дитину</strong>
        </p>
        <p>Діти повинні знати, що це нормально ділитися своїми почуттями з вами, і що це нормально – засмучуватися.</p>
        <p>
          Підтримуйте постійний діалог зі своєю дитиною. Вам не потрібно пояснювати більше, ніж він готовий почути, або
          використовувати графічні описи. Найважливіше – це дати дитині зрозуміти, що ви готові слухати.
        </p>
        <p>
          <strong>Розпаліть надію і зробіть щось позитивне</strong>
        </p>
        <p>
          Один із найкращих способів зменшити почуття тривоги та безнадійності – допомогти дітям знайти активні способи
          розвіяти свої страхи.
        </p>
        <p>
          Це також дає можливість дітям усвідомити, що вони можуть змінити ситуацію у світі, який може здатися страшним
          і небезпечним. Наприклад, допоможіть своїй дитині малювати, писати або надсилати електронні листи, щоб
          висловити подяку військовим.
        </p>
        <p>
          <strong>Виділіть час для сімейних розваг</strong>
        </p>
        <p>
          Під час стресу ваша дитина повинна відчувати, що її обіймає її сім&apos;я. Ось чому гарна ідея приділяти багато
          часу спільним заняттям – це допомагає їй відчувати себе в безпеці та посилає повідомлення &quot;ми всі в цьому
          разом&quot;.
        </p>
        <p>
          <strong>
            Знайдіть заняття для зняття напруги, якими може займатися вся сім&apos;я разом. Наприклад, гуляйте чи катайтеся
            на велосипеді, слухайте заспокійливу музику чи дивіться смішні відео з котиками на ютубі
          </strong>
        </p>
        <p>
          <strong>
            Діти можуть навчитися використовувати деякі прийоми, які використовують дорослі, щоб впоратися з напругою
          </strong>
        </p>
        <p>
          <strong>&quot;Розмова з собою&quot;</strong>. Навчіть дитину говорити в голові слова, щоб допомогти їй
          зберігати спокій і впоратися зі стресом. Ось кілька: &quot;Я можу зробити це.&quot; &quot;Зберігайте спокій і
          дихайте повільно&quot;. Або &quot;Це нічого, з чим я не можу впоратися&quot;.
        </p>
        <p>
          <strong>&quot;Дихання &quot;ліфт&quot;&quot;</strong>. Попросіть дитину закрити очі, тричі повільно видихнути,
          а потім уявіть, що він у ліфті на вершині дуже високої будівлі. Він натискає кнопку першого поверху й
          дивиться, як кнопки кожного рівня повільно світяться, коли ліфт опускається вниз. Коли ліфт спускається, його
          напруга зникає.
        </p>
        <p>
          <strong>Обмежте перегляд новин</strong>. Занадто багато телебачення - це погано. Якщо ваші діти дивляться
          новини, зверніть їхню увагу на історії героїв; це важливо, щоб переконати їх, що у світі є щось більше, ніж
          загрози та страх. І, звичайно, обмежте їх вплив на жорстокі шоу – вони, як правило, посилюють наявну тривогу.
        </p>
        <p>
          <strong>Навчіть дітей висловлювати свої почуття</strong>. Багато дітей демонструють агресію, таку як брикання,
          крик, удари та кусання, тому що вони не знають, як висловити своє розчарування іншим способом. Їм потрібен
          словник емоцій, і ви можете допомогти своїй дитині розвинути його, щоб сказати, що він відчуває до свого
          кривдника: &quot;Я злий&quot;. Або: &quot;Я дуже-дуже злий&quot;.
        </p>
        <p>
          <strong>Обговоріть війну та політику всією сім&apos;єю</strong>. Постійна увага ЗМІ до майбутньої війни створює
          багато &quot;моментів навчання&quot;, щоб поділитися своїми політичними поглядами з вашими дітьми ( звичайно
          це стосується дітей старшого віку).
        </p>
        <p>
          Ми не повинні захищати наших дітей від новин про можливу повномасштабну війну, але й не повинні дозволяти їм
          зациклюватися на ній або розглядати світ як зло, небезпечне місце. Частина нашої роботи як батьків полягає в
          тому, щоб допомогти нашим дітям навчитися жити щасливо в реальному світі, яким би недосконалим він не був.
        </p>

        <StaticImage
          className="image top-spacing-small"
          layout="constrained"
          width={300}
          formats={['auto', 'webp', 'avif']}
          src="../../images/how-to-help-children-overcome-anxiety-during-the-war-1.jpg"
          alt=""
        />
      </article>
    </Layout>
  );
};

export default HowToHelpChildrenOvercomeAnxietyDuringTheWarPage;

export const Head = () => <SEO title="Як допомогти дітям подолати тривогу під час війни?" />;
